import { init } from '@feathery/react';
import type { PropsWithChildren } from 'react';
import { useEffect, useState } from 'react';

type FeatheryProviderProps = PropsWithChildren<object>;

export const FeatheryProvider = ({ children }: FeatheryProviderProps) => {
  const [initialized, setInitialized] = useState(false);

  const initFeathery = async () => {
    await init(import.meta.env.VITE_FEATHERY_SDK_KEY);
    setInitialized(true);
  };

  useEffect(() => {
    if (import.meta.env?.['VITE_FEATHERY_IS_ENABLED'] === 'true') {
      initFeathery();
    } else {
      setInitialized(true);
    }
  }, []);

  return <>{initialized && children}</>;
};
